import { z } from 'zod';

import {
  PurchaseDraftPayloadSchema,
  PurchaseDraftSchema,
  PurchaseLineInputSchema,
  StationContextRefSchema,
} from './purchases.schema.js';
import {
  purchaseDraftUpdateModeValues,
  type AddPurchaseDraftLineRequest,
  type AddPurchaseDraftLineResponse,
  type ApplyPurchaseDraftLineAdjustmentRequest,
  type ApplyPurchaseDraftLineAdjustmentResponse,
  type ClearPurchaseDraftLineAdjustmentRequest,
  type ClearPurchaseDraftLineAdjustmentResponse,
  type DiscardPurchaseDraftRequest,
  type DiscardPurchaseDraftResponse,
  type GetPurchaseDraftRequest,
  type GetPurchaseDraftResponse,
  type PurchaseDraftUpdateMode,
  type UpdatePurchaseDraftRequest,
  type UpdatePurchaseDraftResponse,
} from './purchases-draft.dto.js';

export const PurchaseDraftUpdateModeSchema: z.ZodType<PurchaseDraftUpdateMode> = z.enum(
  purchaseDraftUpdateModeValues,
);

export const GetPurchaseDraftRequestSchema: z.ZodType<GetPurchaseDraftRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
    laneId: z.string().trim().min(1).max(64).nullable().optional(),
  });

export const GetPurchaseDraftResponseSchema: z.ZodType<GetPurchaseDraftResponse> =
  z.object({
    draft: PurchaseDraftSchema.nullable(),
  });

export const UpdatePurchaseDraftRequestSchema: z.ZodType<UpdatePurchaseDraftRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  laneId: z.string().trim().min(1).max(64).nullable().optional(),
  mode: PurchaseDraftUpdateModeSchema.optional(),
  payload: PurchaseDraftPayloadSchema,
});

export const UpdatePurchaseDraftResponseSchema: z.ZodType<UpdatePurchaseDraftResponse> = z.object({
  draft: PurchaseDraftSchema.nullable(),
});

export const AddPurchaseDraftLineRequestSchema: z.ZodType<AddPurchaseDraftLineRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  laneId: z.string().trim().min(1).max(64).nullable().optional(),
  line: PurchaseLineInputSchema,
});

export const AddPurchaseDraftLineResponseSchema: z.ZodType<AddPurchaseDraftLineResponse> = z.object({
  draft: PurchaseDraftSchema,
});

export const ApplyPurchaseDraftLineAdjustmentRequestSchema: z.ZodType<ApplyPurchaseDraftLineAdjustmentRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
    laneId: z.string().trim().min(1).max(64).nullable().optional(),
    draftId: z.uuid(),
    lineId: z.uuid(),
    presetId: z.uuid(),
  });

export const ApplyPurchaseDraftLineAdjustmentResponseSchema: z.ZodType<ApplyPurchaseDraftLineAdjustmentResponse> =
  z.object({
    draft: PurchaseDraftSchema,
  });

export const ClearPurchaseDraftLineAdjustmentRequestSchema: z.ZodType<ClearPurchaseDraftLineAdjustmentRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
    laneId: z.string().trim().min(1).max(64).nullable().optional(),
    draftId: z.uuid(),
    lineId: z.uuid(),
  });

export const ClearPurchaseDraftLineAdjustmentResponseSchema: z.ZodType<ClearPurchaseDraftLineAdjustmentResponse> =
  z.object({
    draft: PurchaseDraftSchema,
  });

export const DiscardPurchaseDraftRequestSchema: z.ZodType<DiscardPurchaseDraftRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  laneId: z.string().trim().min(1).max(64).nullable().optional(),
});

export const DiscardPurchaseDraftResponseSchema: z.ZodType<DiscardPurchaseDraftResponse> = z.object({
  discarded: z.boolean(),
  station: StationContextRefSchema,
});
